/* Northsheep — Bundle & save (snippets/ns-bundle-tiers.liquid).

   Picking a bundle sets the quantity and opens one colour choice per piece
   (owner, 26 Sep 2026: "any colour mix should count" — every colour of the
   product counts towards the Shopify discount). Add to basket then adds
   exactly those pieces in one request. A single piece goes through Dawn's own
   form, untouched.

   Each piece is a row of photo circles, one radio group per piece (owner,
   28 Sep 2026: the native dropdown looked "a bit basic").

   The discount is not decided here: it is an automatic Shopify discount per
   product, so the basket and the checkout apply it whatever this file does.

   Registered once, on document: a colour swap re-renders <main> and re-runs
   this file, so a second run only redraws what is on the page now. */
(function () {
  if (window.__nsBundle) {
    window.__nsBundle.refresh();
    return;
  }

  function boxOf(el) {
    return el && el.closest ? el.closest('[data-ns-bundle]') : null;
  }

  function variantsOf(box) {
    var node = box.querySelector('[data-ns-bundle-variants]');
    try {
      return JSON.parse(node.textContent) || [];
    } catch (err) {
      return [];
    }
  }

  function findVariant(list, id) {
    for (var i = 0; i < list.length; i++) {
      if (String(list[i].id) === String(id)) return list[i];
    }
    return null;
  }

  function tierOf(box) {
    var r = box.querySelector('.ns-bundle__radio:checked');
    return r ? parseInt(r.value, 10) || 1 : 0;
  }

  /* The lines about the 15 % on accessories say what THIS choice gets (owner, 30 Sep 2026). A skin at its set price
     cannot unlock that 15 % (Shopify only lets an item at its normal price unlock a Buy X get Y), so while a set price
     applies the buy box shows its saving and "Often bought together" its plain line; back at one piece, the offer
     returns. The QUANTITY decides (3 pieces are a set and one at full price), and the saving comes from the block's
     list, worked out the way Shopify applies the sets and formatted by the shop (data-saves). The page marks
     data-ns-keep-offer when the basket already holds another skin that earns the offer at its normal price: then
     nothing changes. */
  function offerMode(box) {
    var root = document.getElementById('MainProduct-' + box.dataset.section) || document;
    var q = qtyInput(box);
    var n = q ? parseInt(q.value, 10) || 1 : tierOf(box);
    var saves = {};
    try {
      saves = JSON.parse(box.getAttribute('data-saves') || '{}') || {};
    } catch (err) {
      saves = {};
    }
    var save = saves[String(n)] || '';
    var set = !!save && !root.querySelector('[data-ns-keep-offer]');
    var i;
    var off = root.querySelectorAll('[data-ns-offer-line], [data-ns-offer-sub]');
    for (i = 0; i < off.length; i++) off[i].hidden = set;
    var lines = root.querySelectorAll('[data-ns-set-line]');
    for (i = 0; i < lines.length; i++) {
      var tx = lines[i].querySelector('[data-ns-set-line-text]');
      if (set && tx) {
        /* The saving stays in one piece (no line break inside "10,00 €"), and the line's last word sits with the ⓘ in
           its nowrap span, so the icon never drops onto a line of its own (snippets/ns-offer-info-tail.liquid). */
        var full = (lines[i].getAttribute('data-tpl') || '').replace('§§', String(save).replace(/ /g, ' '));
        var cut = full.lastIndexOf(' ');
        var lastEl = lines[i].querySelector('[data-ns-set-line-last]');
        if (lastEl) {
          tx.textContent = cut > -1 ? full.slice(0, cut + 1) : '';
          lastEl.textContent = cut > -1 ? full.slice(cut + 1) : full;
        } else {
          tx.textContent = full;
        }
      }
      lines[i].hidden = !set;
    }
    var subs = root.querySelectorAll('[data-ns-set-sub]');
    for (i = 0; i < subs.length; i++) subs[i].hidden = !set;
  }

  function formOf(box) {
    return document.getElementById(box.dataset.form);
  }

  function chosenVariant(box) {
    var f = formOf(box);
    var input = f && f.querySelector('input[name="id"]');
    return input ? String(input.value) : '';
  }

  function qtyInput(box) {
    return document.getElementById('Quantity-' + box.dataset.section);
  }

  function setQty(box, n) {
    var q = qtyInput(box);
    if (!q || String(q.value) === String(n)) return;
    q.value = n;
    q.dispatchEvent(new Event('change', { bubbles: true }));
  }

  /* The colour each piece has now, in order ('' where none is chosen). */
  function picks(box) {
    var rows = box.querySelectorAll('.ns-bundle__piece');
    var out = [];
    for (var i = 0; i < rows.length; i++) {
      var c = rows[i].querySelector('.ns-bundle__sw-input:checked');
      out.push(c ? c.value : '');
    }
    return out;
  }

  /* "Colour for piece #" from the locale, with the number put in. */
  function pieceLabel(box, n) {
    var t = box.dataset.pieceLabel || '#';
    return t.indexOf('#') > -1 ? t.replace('#', String(n)) : t + ' ' + n;
  }

  function nameRow(row, list) {
    var c = row.querySelector('.ns-bundle__sw-input:checked');
    var v = c ? findVariant(list, c.value) : null;
    var name = row.querySelector('.ns-bundle__piece-name');
    if (name) name.textContent = v ? v.title : '';
  }

  /* keep = hold on to the colours already chosen when the count changes. */
  function drawPieces(box, keep) {
    var n = tierOf(box);
    var mix = box.querySelector('[data-ns-bundle-mix]');
    var wrap = box.querySelector('[data-ns-bundle-slots]');
    if (!mix || !wrap) return;
    var list = variantsOf(box);
    /* One colour in stock leaves nothing to choose: Dawn's form adds the
       bundle's count of it. */
    if (n <= 1 || list.length < 2) {
      mix.hidden = true;
      wrap.innerHTML = '';
      return;
    }
    var before = keep ? picks(box) : [];
    var current = chosenVariant(box);
    if (!findVariant(list, current)) current = String(list[0].id);
    var sid = box.dataset.section || 'x';
    wrap.innerHTML = '';
    for (var i = 0; i < n; i++) {
      var want = before[i] && findVariant(list, before[i]) ? before[i] : current;

      var row = document.createElement('div');
      row.className = 'ns-bundle__piece';
      row.setAttribute('role', 'radiogroup');
      row.setAttribute('aria-label', pieceLabel(box, i + 1));

      var head = document.createElement('span');
      head.className = 'ns-bundle__piece-head';
      head.setAttribute('aria-hidden', 'true');
      var no = document.createElement('span');
      no.className = 'ns-bundle__piece-no';
      no.textContent = String(i + 1);
      var name = document.createElement('span');
      name.className = 'ns-bundle__piece-name';
      head.appendChild(no);
      head.appendChild(name);

      var sws = document.createElement('span');
      sws.className = 'ns-bundle__sws';
      for (var o = 0; o < list.length; o++) {
        var v = list[o];
        var sw = document.createElement('label');
        sw.className = 'ns-bundle__sw';
        sw.title = v.title;
        var input = document.createElement('input');
        input.type = 'radio';
        input.className = 'ns-bundle__sw-input';
        input.name = 'ns-bundle-' + sid + '-piece-' + (i + 1);
        input.value = String(v.id);
        input.setAttribute('aria-label', v.title);
        if (String(v.id) === String(want)) input.checked = true;
        var pic = document.createElement('span');
        pic.className = 'ns-bundle__sw-pic';
        if (v.image) {
          var img = document.createElement('img');
          img.src = v.image;
          img.alt = '';
          img.width = 40;
          img.height = 40;
          img.decoding = 'async';
          // A photo on white: placed so the piece itself fills the circle (5 Oct 2026, ns-bundle-tiers.liquid "fit").
          if (v.fit && v.ar) {
            img.className = 'ns-fit';
            img.height = Math.round(40 / v.ar);
            img.style.setProperty('--nf-w', v.fit[0] + '%');
            img.style.setProperty('--nf-l', v.fit[1] + '%');
            img.style.setProperty('--nf-t', v.fit[2] + '%');
          }
          pic.appendChild(img);
        } else {
          pic.className += ' ns-bundle__sw-pic--text';
          pic.textContent = String(v.title || '').slice(0, 2);
        }
        sw.appendChild(input);
        sw.appendChild(pic);
        sws.appendChild(sw);
      }

      row.appendChild(head);
      row.appendChild(sws);
      wrap.appendChild(row);
      nameRow(row, list);
    }
    mix.hidden = false;
  }

  function refresh() {
    var boxes = document.querySelectorAll('[data-ns-bundle]');
    for (var i = 0; i < boxes.length; i++) {
      var box = boxes[i];
      if (tierOf(box) > 1) {
        setQty(box, tierOf(box));
        drawPieces(box, true);
      }
      offerMode(box);
    }
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.classList) return;
    var box = boxOf(t);
    if (box && t.classList.contains('ns-bundle__radio')) {
      setQty(box, parseInt(t.value, 10) || 1);
      drawPieces(box, true);
      offerMode(box);
      return;
    }
    if (box && t.classList.contains('ns-bundle__sw-input')) {
      var row = t.closest('.ns-bundle__piece');
      if (row) nameRow(row, variantsOf(box));
      box.dataset.custom = '1';
      return;
    }
    /* The shopper stepped or typed a quantity: the cards follow it. A number
       that is no bundle clears the choice rather than pretending. */
    if (t.name === 'quantity' && t.id && t.id.indexOf('Quantity-') === 0) {
      var b = document.querySelector('[data-ns-bundle][data-section="' + t.id.slice(9) + '"]');
      if (!b) return;
      var val = parseInt(t.value, 10) || 1;
      var match = b.querySelector('.ns-bundle__radio[value="' + val + '"]');
      var radios = b.querySelectorAll('.ns-bundle__radio');
      for (var i = 0; i < radios.length; i++) radios[i].checked = radios[i] === match;
      drawPieces(b, true);
      offerMode(b);
    }
  });

  /* A new colour in the main picker: the pieces follow it until the shopper
     has chosen colours of their own. Dawn re-draws the quantity box on a
     variant change, so the bundle's count is put back as well. */
  function onVariant() {
    var boxes = document.querySelectorAll('[data-ns-bundle]');
    for (var i = 0; i < boxes.length; i++) {
      var box = boxes[i];
      if (tierOf(box) > 1) {
        setQty(box, tierOf(box));
        drawPieces(box, box.dataset.custom === '1');
      }
      offerMode(box);
    }
  }
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, function () {
      window.setTimeout(onVariant, 60);
    });
  }

  /* Dawn puts the quantity back to its minimum after every basket change
     (product-info.js setQuantityBoundries, on cartUpdate) and announces it
     with quantityUpdate, while "2 for …" stayed selected: a one-colour set
     then added one piece at its full price (audit, 2 Oct 2026). The chosen
     set's count is put back, and the shopper's colours are kept. */
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.quantityUpdate) {
    subscribe(PUB_SUB_EVENTS.quantityUpdate, function () {
      var boxes = document.querySelectorAll('[data-ns-bundle]');
      for (var i = 0; i < boxes.length; i++) {
        if (tierOf(boxes[i]) > 1) setQty(boxes[i], tierOf(boxes[i]));
      }
    });
  }

  /* Add to basket with a bundle chosen: add every piece in its own colour.
     Capture phase on document, so Dawn's own submit handler never sees it. */
  document.addEventListener(
    'submit',
    function (e) {
      var f = e.target;
      /* getAttribute, not f.id: the form holds an <input name="id">, and a
         form's named fields shadow its own properties — f.id IS that input. */
      var fid = f && f.getAttribute ? f.getAttribute('id') : '';
      if (!fid) return;
      var box = document.querySelector('[data-ns-bundle][data-form="' + fid + '"]');
      if (!box || tierOf(box) <= 1) return;
      var chosen = picks(box).filter(Boolean);
      if (!chosen.length) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      /* Still adding (addPieces marks the button busy): a second tap is not a
         second set. This handler takes the submit before Dawn's, so Dawn's own
         aria-disabled guard never ran (audit 2 Oct 2026: a double tap added
         the set twice). */
      var busyBtn = f.querySelector('[type="submit"]');
      if (busyBtn && busyBtn.getAttribute('aria-disabled') === 'true') return;
      var counts = {};
      var order = [];
      for (var i = 0; i < chosen.length; i++) {
        var id = chosen[i];
        if (!counts[id]) order.push(id);
        counts[id] = (counts[id] || 0) + 1;
      }
      var lines = order.map(function (id) {
        return { id: Number(id), quantity: counts[id] };
      });
      /* Extra lines that go with every piece, e.g. "Add a filling" (assets/ns-filling.js). */
      (window.__nsCartExtras || []).forEach(function (fn) {
        try {
          /* In front: Shopify lists the last line of a request first, so the pieces show above their extras. */
          lines = (fn(f, chosen.length) || []).concat(lines);
        } catch (err) {
          /* an extra that fails never blocks the set */
        }
      });
      addPieces(box, f, lines);
    },
    true
  );

  function addPieces(box, form, items) {
    var btn = form.querySelector('[type="submit"]');
    var err = box.querySelector('[data-ns-bundle-error]');
    if (err) {
      err.hidden = true;
      err.textContent = '';
    }
    var spin = btn && btn.querySelector('.loading__spinner');
    if (btn) {
      btn.classList.add('loading');
      btn.setAttribute('aria-disabled', 'true');
    }
    if (spin) spin.classList.remove('hidden');
    var drawer = document.querySelector('cart-drawer');
    var onCartPage = !!document.getElementById('main-cart-items');
    var sections = onCartPage
      ? ['main-cart-items', 'main-cart-footer', 'cart-icon-bubble']
      : drawer && drawer.getSectionsToRender
        ? drawer.getSectionsToRender().map(function (s) {
            return s.id;
          })
        : ['cart-drawer', 'cart-icon-bubble'];
    var done = function () {
      if (btn) {
        btn.classList.remove('loading');
        btn.removeAttribute('aria-disabled');
      }
      if (spin) spin.classList.add('hidden');
    };
    /* A bare fetch fires none of Dawn's cart events; everything that
       follows the basket (the free gift above all) listens for this. No
       cartData: the add answers with the added lines, not the basket. */
    var notify = function () {
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ns-bundle' });
      }
    };
    fetch(((window.routes && routes.cart_add_url) || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items, sections: sections.join(','), sections_url: window.location.pathname }),
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (resp) {
        done();
        if (resp.status) {
          if (err) {
            err.textContent = resp.description || resp.message || '';
            err.hidden = false;
          }
          /* Shopify stops at a piece's stock but keeps what it could add (and
             every filling, which is not stocked): the basket must catch up.
             This answer carries no sections, so they are asked for (audit,
             2 Oct 2026): the count by the basket icon and the drawer's empty
             layout used to stay as they were. The drawer is not opened — the
             message above says what happened. */
          if (drawer) redrawDrawer(drawer);
          notify();
          return;
        }
        if (drawer && typeof drawer.renderContents === 'function') {
          drawer.renderContents(resp);
          /* renderContents leaves the drawer's own is-empty class alone, and a
             first add to an empty basket then opened in the empty layout: no
             header, squashed rows (29 Sep 2026). Dawn's form clears it itself. */
          drawer.classList.toggle('is-empty', !!drawer.querySelector('.drawer__inner-empty'));
        } else {
          window.location.href = (window.routes && routes.cart_url) || '/cart';
          return;
        }
        notify();
      })
      .catch(done);
  }

  function redrawDrawer(drawer) {
    if (typeof drawer.getSectionsToRender !== 'function' || typeof drawer.getSectionInnerHTML !== 'function') return;
    var list = drawer.getSectionsToRender();
    var url = window.location.pathname + '?sections=' + list.map(function (s) { return s.id; }).join(',');
    fetch(url)
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (json) {
        if (!json) return;
        list.forEach(function (s) {
          var el = s.selector ? document.querySelector(s.selector) : document.getElementById(s.id);
          if (el && json[s.id]) el.innerHTML = drawer.getSectionInnerHTML(json[s.id], s.selector);
        });
        drawer.classList.toggle('is-empty', !!drawer.querySelector('.drawer__inner-empty'));
      })
      .catch(function () {});
  }

  window.__nsBundle = { refresh: refresh };
  refresh();
})();
